/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Type_LocationInputs */

const en_knp_terms_type_location = /** @type {(inputs: Knp_Terms_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const fr_knp_terms_type_location = /** @type {(inputs: Knp_Terms_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieu`)
};

const de_knp_terms_type_location = /** @type {(inputs: Knp_Terms_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort`)
};

const it_knp_terms_type_location = /** @type {(inputs: Knp_Terms_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione`)
};

const ru_knp_terms_type_location = /** @type {(inputs: Knp_Terms_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расположение`)
};

const es_knp_terms_type_location = /** @type {(inputs: Knp_Terms_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación`)
};

const zh_cn2_knp_terms_type_location = /** @type {(inputs: Knp_Terms_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地点`)
};

const ja_knp_terms_type_location = /** @type {(inputs: Knp_Terms_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置`)
};

const hi_knp_terms_type_location = /** @type {(inputs: Knp_Terms_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जगह`)
};

const pt_pt2_knp_terms_type_location = /** @type {(inputs: Knp_Terms_Type_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Localização`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Knp_Terms_Type_LocationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_type_location = /** @type {((inputs?: Knp_Terms_Type_LocationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Type_LocationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_type_location(inputs)
	if (locale === "de") return de_knp_terms_type_location(inputs)
	if (locale === "it") return it_knp_terms_type_location(inputs)
	if (locale === "ru") return ru_knp_terms_type_location(inputs)
	if (locale === "es") return es_knp_terms_type_location(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_type_location(inputs)
	if (locale === "ja") return ja_knp_terms_type_location(inputs)
	if (locale === "hi") return hi_knp_terms_type_location(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_type_location(inputs)
	return en_knp_terms_type_location(inputs)
});